export default "<payment-partners\n  model=\"vm.model.debitsAndDepositsBlacklist\"\n  form=\"vm.form\">\n</payment-partners>\n";